var map = {
	"./aml_compliance/en.json": [
		"07ad",
		"chunk-2d0a4d60"
	],
	"./aml_compliance/es.json": [
		"5d6e",
		"chunk-2d0d36f4"
	],
	"./aml_compliance/pt.json": [
		"1590",
		"chunk-2d0ab531"
	],
	"./complaints_channel/en.json": [
		"f8f5",
		"chunk-2d22dd97"
	],
	"./complaints_channel/es.json": [
		"ec680",
		"chunk-773d961a"
	],
	"./complaints_channel/pt.json": [
		"9b68",
		"chunk-2d0f00c1"
	],
	"./continuous_audit/en.json": [
		"f5c5",
		"chunk-2d22d1f7"
	],
	"./continuous_audit/es.json": [
		"b4ce",
		"chunk-2d20fcea"
	],
	"./continuous_audit/pt.json": [
		"87f7",
		"chunk-2d0df0c6"
	],
	"./cross_lists/en.json": [
		"6922",
		"chunk-2d0d0939"
	],
	"./cross_lists/es.json": [
		"0d02",
		"chunk-2d0af02c"
	],
	"./cross_lists/pt.json": [
		"c707",
		"chunk-2d217631"
	],
	"./fraud_prevention/en.json": [
		"32fb",
		"chunk-2d0b9851"
	],
	"./fraud_prevention/es.json": [
		"83f2",
		"chunk-2d0de1bd"
	],
	"./fraud_prevention/pt.json": [
		"b422",
		"chunk-2d20f6c8"
	],
	"./management_indicators/en.json": [
		"f265",
		"chunk-2d22c141"
	],
	"./management_indicators/es.json": [
		"7596",
		"chunk-2d0d6f71"
	],
	"./management_indicators/pt.json": [
		"6528",
		"chunk-2d0cfa3b"
	],
	"./market_abuse/en.json": [
		"e9f2",
		"chunk-2d226cf6"
	],
	"./market_abuse/es.json": [
		"5afc",
		"chunk-2d0d317f"
	],
	"./market_abuse/pt.json": [
		"9612",
		"chunk-2d0e5af4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7915";
module.exports = webpackAsyncContext;